module.exports = __webpack_public_path__ + "static/media/masterclass-affiliate-banner.cfb96c7d.png";